import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { toJS } from "mobx";
import { useStore } from "../../helpers";
import { LoadingState } from "../../components/LoadingState";
import {
    DonutChart3d,
    LineChart,
    MultipleValueLineChart,
    StackBarChart,
} from "../../components/Charts";

export const PrintMediaReportSummary = observer(() => {
    const { mediaStore } = useStore();
    const { printMediaFilters } = mediaStore;
    const { from_date, to_date, lang, sources } = printMediaFilters;

    const [articlesByDate, setArticlesByDate] = useState([]);
    const [articlesByMediaSource, setArticlesByMediaSource] = useState([]);
    const [totalArticles, setTotalArticles] = useState(0);
    const [comparisionByArticles, setComparisionByArticles] = useState([]);
    const [comparisionByMedia, setComparisionByMedia] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const refreshData = async () => {
            setLoading(true);
            await mediaStore.getArticles();
            if (!mediaStore.articles) {
                setLoading(false);
                return;
            }
            setArticlesByDate(toJS(mediaStore.articles["analysis"]["total articles"]));
            setArticlesByMediaSource(toJS(mediaStore.articles["analysis"]["sources"]));
            setTotalArticles(toJS(mediaStore.articles["total"]));
            setComparisionByArticles(toJS(mediaStore.articles["comparison"]["total articles"]));
            setComparisionByMedia(toJS(mediaStore.articles["analysis"]["total_source"]));
            setLoading(false);
        };
        void refreshData();
    }, [from_date, to_date, lang, sources, mediaStore]);

    return (
        <div className="flex flex-col">
            <div className="flex flex-col py-2 lg:py-4">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col items-center justify-center rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg lg:h-36">
                        <p className="lg:text-xl">Total Articles</p>
                        <p className="lg:text-5xl">{totalArticles}</p>
                    </div>
                    <div className="flex flex-col items-center justify-center rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg lg:h-36">
                        <p className="lg:text-xl">Total Mentions</p>
                        <p className="lg:text-5xl">0</p>
                    </div>
                </div>
            </div>
            {loading ? <LoadingState /> : null}
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
                <div className="flex flex-col rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg" style={{ height: 550 }}>
                    <div className="px-4 pb-4 text-2xl">Articles by Date</div>
                    <LineChart chartId="pm_articles_by_date" data={articlesByDate} label="date" value="articles" />
                </div>
                <div className="flex flex-col rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg" style={{ height: 550 }}>
                    <div className="px-4 pb-4 text-2xl">Articles by Media Source</div>
                    <StackBarChart chartId="pm_articles_by_source" data={articlesByMediaSource} label="date" />
                </div>
                <div className="flex flex-col rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg" style={{ height: 550 }}>
                    <div className="px-4 pb-4 text-2xl">Comparision by Articles</div>
                    <MultipleValueLineChart chartId="pm_comparison_articles" data={comparisionByArticles} label="date" />
                </div>
                <div className="flex flex-col rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg" style={{ height: 550 }}>
                    <div className="px-4 pb-4 text-2xl">Comparision by Media sources</div>
                    <DonutChart3d data={comparisionByMedia} _label="media_source" value="article_count" />
                </div>
            </div>
        </div>
    );
});
